import React from "react";

const CampaignPrizeOrdersList = React.lazy(() => import('src/pages/campaign_prize_orders/CampaignPrizeOrdersList'));
const CampaignPrizeOrderDetail = React.lazy(() => import('src/pages/campaign_prize_orders/CampaignPrizeOrderDetail'));

const routes = [
    { path: '/dashboard/campaign-prize-orders-list/detail/:id', name: 'Prize Order Detail', element: CampaignPrizeOrderDetail },
    { path: '/dashboard/campaign-prize-orders-list', name: 'Campaign Prize Orders', element: CampaignPrizeOrdersList },
];

export default routes;
